namespace Matrix.Workflow {
    export interface TaskStatusRow {
        StatusCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace TaskStatusRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'StatusCode';
        export const localTextPrefix = 'Workflow.TaskStatus';
        export const deletePermission = 'DataAdmin:TaskStatus';
        export const insertPermission = 'DataAdmin:TaskStatus';
        export const readPermission = 'Read:TaskStatus';
        export const updatePermission = 'DataAdmin:TaskStatus';

        export declare const enum Fields {
            StatusCode = "StatusCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
